module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="#292929" fill-rule="evenodd" d="M14.695.563L7.91 7.383l6.785 6.785-.527.562-6.82-6.82-6.785 6.82L0 14.168l6.785-6.785L0 .563.563 0l6.785 6.82L14.168 0z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/raw/icon_close_notify.svg
// module id = 1822
// module chunks = 7